<div [id]="id" class="collapseable-row light-gray">
  <div *ngIf="isCollapsed" class="container-fluid" (click)="collapseRow()">
    <div class="row">
      <div *ngIf="imgSrc" class="row-icon fill-black" aria-label="icon" [inlineSVG]=imgSrc ></div>
      <div [ngClass]="{'uppercase': titleIsUpperCase, 'title-text': imgSrc, 'title-text-no-icon': !imgSrc}"><span [innerHTML]="title"></span></div>
      <div class="three-dots">
        <div class="group">
          <button>
            <img src="assets/ico/three-dots.svg" alt="user" />
          </button>
        </div>
      </div>
    </div>
  </div>
  <div [ngbCollapse]="isCollapsed" (click)="collapse($event)">
    <ng-content></ng-content>
  </div>
</div>